import { useCallback, useEffect, useState } from 'react';
import { ErrorHandler } from '../Services/UserApi';
import AccountService, { AccountDetails, SaveDetailsPayload } from '../Services/AccountService';
import useHash from './UseHash';

export default function useAccountDetails() {
	const [details, setDetails] = useState<AccountDetails>();
	const [isLoading, setIsLoading] = useState(true);

	const hash = useHash();

	const loadDetails = useCallback(async () => {
		setIsLoading(true);
		try {
			const loaded = await AccountService.getDetails(hash);
			setDetails(loaded);
			return loaded;
		} catch (error) {
			ErrorHandler.toast(error);
			return undefined;
		} finally {
			setIsLoading(false);
		}
	}, [hash]);

	const saveDetails = useCallback(
		async (payload: SaveDetailsPayload) => {
			const updated = await AccountService.saveDetails(hash, payload);
			setDetails(updated);
			return updated;
		},
		[hash],
	);

	useEffect(() => {
		void loadDetails();
	}, [loadDetails]);

	return {
		details,
		isLoading,
		loadDetails,
		saveDetails,
	};
}
